import Events from '@utilities/events'
import ScreenDimensions from '@utilities/screen-dimensions'
import AccordionItem from './accordion-item'

const REFINEMENT_ID = 'refinement'
const ACCORDION_ITEM_HOOK = 'js-hook-accordion-item'
const JS_HOOK_SHOW_MORE_STORES = 'js-hook-show-more-stores'
const JS_HOOK_SHOW_LESS_STORES = 'js-hook-show-less-stores'
const SHOW_MORE_BTN_VISIBLE = 'store__show-more--visible'
const SHOW_LESS_BTN_VISIBLE = 'store__show-less--visible'
const STORE_ACCORDION_ITEM = 'store__accordion-item'
const STORE_ACCORDION_ITEM_HIDDEN = 'store__accordion-item--hidden'
const stores = document.getElementsByClassName(STORE_ACCORDION_ITEM)

class Accordion {
  constructor(element) {
    this.element = element
    this.items = this.element.querySelectorAll(`[${ACCORDION_ITEM_HOOK}]`)
    this.showMoreButton = document.querySelector(`[${JS_HOOK_SHOW_MORE_STORES}]`)
    this.showLessButton = document.querySelector(`[${JS_HOOK_SHOW_LESS_STORES}]`)

    this.refinementItems = [
      ...document.querySelectorAll(`[${ACCORDION_ITEM_HOOK}^=${REFINEMENT_ID}]`),
    ]

    if (!this.items) {
      return
    }

    this.autoClose = this.element.dataset.autoclose !== 'false'
    this.accordionItems = {}
    this._initItems()

    if (this.showMoreButton && this.showLessButton) {
      this._initStores();
      this.bindEvents();
    }
  }

  /**
   * Bind all accordion specific events
   * @param {HTMLElement} item  | accordion item
   */
  _bindAccordionEvents({ id }) {
    Events.$on(`accordion[${id}]::close`, () => {
      if (id && this.accordionItems[id] && !this.isAnimating) {
        this.accordionItems[id].close()
      }

      if (!id && !this.isAnimating) {
        Object.keys(this.accordionItems).forEach((i) => {
          this.accordionItems[i].close()
        })
      }
    })

    Events.$on(`accordion[${id}]::open`, () => {
      if (id && this.accordionItems[id] && !this.isAnimating) {
        this._closeAllChildren(id)
        this.accordionItems[id].open()
      }
    })

    Events.$on(`accordion[${id}]::toggle`, () => {
      if (id && this.accordionItems[id] && !this.isAnimating) {
        this._closeAllChildren(id)
        this.accordionItems[id].toggle()
      }
    })

    Events.$on(`accordion[${id}]::animating`, (event, data) => {
      if (this.accordionItems[data.id]) {
        this.isAnimating = data.animating
      }
    })
  }

  closeAllRefinements(currentId) {
    if (!ScreenDimensions.isTabletPortraitAndBigger) return
    this.refinementItems.forEach((item) => {
      const itemId = item.getAttribute(ACCORDION_ITEM_HOOK)
      if (itemId !== currentId) Events.$trigger(`accordion[${itemId}]::close`)
    })
  }

  /**
   * Iterate over each item inside the accordion and check if there is more then 4 stores.
   * If it is more then it will hide every next and will make visible show more button.
   * Else is used for removing button's visibility classes in case that we don't have
   * store's near new searched location.
   */
  _initItems() {
    Array.from(this.items).forEach((el) => {
      const item = new AccordionItem(el)
      this.accordionItems[item.id] = item
      this._bindAccordionEvents(this.accordionItems[item.id])
    })
  }

  _initStores() {
    if (stores !== undefined && stores.length > 0) {
      Array.from(stores).forEach((el, index) => {
        const item = el

        if (index > 4) {
          item.classList.add(STORE_ACCORDION_ITEM_HIDDEN)
          this.showMoreButton.classList.add(SHOW_MORE_BTN_VISIBLE)
        }
      })
    } else {
      this.showLessButton.classList.remove(SHOW_LESS_BTN_VISIBLE)
      this.showMoreButton.classList.remove(SHOW_MORE_BTN_VISIBLE)
    }
  }

  /**
   * Get height of given element
   * @param {String} skipId Identifier which should be skipped
   */
  _closeAllChildren(skipId) {
    if (!this.autoClose) {
      return
    }

    Object.keys(this.accordionItems).forEach((id) => {
      if (skipId === id) {
        return
      }
      this.accordionItems[id].close()
    })
  }


  /**
   * 2 button listeners
   * First is for show more stores, basically remove hidden classes from store's that were hidden.
   * Second is opposite, add hidden classes to every other after 5.
   */
  bindEvents() {
    if (stores !== undefined) {
      this.showMoreButton.addEventListener('click', () => {

        Array.from(stores).forEach((el) => {
          el.classList.remove(STORE_ACCORDION_ITEM_HIDDEN);
        })

        this.showMoreButton.classList.remove(SHOW_MORE_BTN_VISIBLE)
        this.showLessButton.classList.add(SHOW_LESS_BTN_VISIBLE)

      }, false);

      this.showLessButton.addEventListener('click', () => {
        this._initStores()

        this.showLessButton.classList.remove(SHOW_LESS_BTN_VISIBLE)

      }, false);
    }
  }
}

export default Accordion
